import axios from "axios";
import { auth } from "../auth/firebase.js";
// import {
//   AXCELERATE_BASE_URL,
//   AXCELERATE_API_TOKEN,
//   AXCELERATE_WS_TOKEN,
//   CONTENT_TYPE_FORM_URLENCODED,
// } from "../../functions/WebAPIConstants.js";

import { COUNTRY_SACC_CODES } from "../CountrySACC.js";

export const functionsURL = "https://app-63xryff43a-uc.a.run.app";
// export const functionsURL = "http://127.0.0.1:5001/admin-ciet/us-central1/app"
// const functionsURL = "https://us-central1-admin-ciet.cloudfunctions.net/app";

export const mapinitialDataToContactData = (initialData) => {
  const personal = initialData.formState.personal || {};
  const languageCulture = initialData.formState.languageCulture || {};
  const campusCourse = initialData.formState.campusCourse || {};
  const usiData = initialData.formState.usi || {};

  return {
    // Required
    GivenName: personal.givenNames || "",
    Surname: personal.familyName || "",

    // Optional personal info
    Title: personal.title || "",
    emailAddress: personal.email || "",
    ContactActive: true,
    dob: personal.dateOfBirth || "", // Convert to YYYY-MM-DD if needed
    sex: personal.gender && personal.gender.charAt(0).toUpperCase() != 'O' ? personal.gender.charAt(0).toUpperCase() : "X",
    middleName: "", // Not present in initialData
    phone: personal.telephone || "",
    mobilephone: personal.mobilePhone || "",
    workphone: "",
    fax: "",

    // Address fields
    address1: personal.address || "",
    address2: "", // No secondary address
    city: personal.suburb || "",
    state: personal.state || "",
    postcode: personal.postcode || "",
    country: COUNTRY_SACC_CODES[personal.country] || '',

    // Organisation fields
    // organisation: "",
    orgId: 1173853,
    // orgIds: [],
    position: "",
    section: "",
    division: "",
    SourceCodeID: "",
    HistoricClientID: "",

    // Student identifiers
    USI: usiData.usi || "",
    LUI: "",
    TFN: "",
    VSN: "",
    WorkReadyParticipantNumber: "",
    SACEStudentID: "",

    // Emergency contacts
    EmergencyContact: "",
    EmergencyContactRelation: "",
    EmergencyContactPhone: "",
    parentContactID: "",

    // Additional info from language/culture
    CountryofBirthID: COUNTRY_SACC_CODES[languageCulture.countryOfBirth] || '',
    CityofBirth: "", // Not available
    Citizenship: personal.citizenship || "",
    IndigenousStatusID: "",

    // Campus/course info
    Course: campusCourse.courses[0] || "",
    Campus: campusCourse.campus || "",

    // AVETMISS / Optional fields
    buildingName: "",
    unitNo: "",
    streetNo: "",
    streetName: "",
    POBox: "",
    saddress1: personal.address || "",
    scity: personal.suburb || "",
    sstate: personal.state || "",
    spostcode: personal.postcode || "",
    scountry: COUNTRY_SACC_CODES[personal.country] || '',

    // Declaration
    declarationSignatureName: initialData.formState.declaration?.signatureName || "",
    declarationSignatureDate: initialData.formState.declaration?.signatureDate || "",

    // Agent info
    agentName: personal.agent?.agencyName || "",
    agentEmail: personal.agent?.email || "",
    agentPhone: personal.agent?.telephone || "",

    // Custom fields placeholder
    customField_example: "",

    // Add any other fields as needed
  }
};
/**
 * Create a contact in Axcelerate
 * @param {Object} contactData - Contact details (givenName, surname, etc.)
 */
export const createAxcelerateContact = async (contactId, initialData) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not signed in");

    const token = await user.getIdToken(); // Firebase ID token
    const contactData = JSON.stringify(mapinitialDataToContactData(initialData));
    let response = {};
    if (contactId == "") {
      response = await axios.post(
        `${functionsURL}/api/contact`,
        contactData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    } else {
      const formData = new FormData();
      formData.append("contactData", JSON.stringify(contactData));
      formData.append("contactId", contactId);
      formData.append("initialData", JSON.stringify(initialData));
      formData.append("visa_currentVisaCopy", JSON.stringify(initialData.formState.visa?.currentVisaCopy || ""));
      formData.append("visa_refusalLetter", JSON.stringify(initialData.formState.visa?.refusalLetter || ""));
      formData.append("usiExemptionLetter", JSON.stringify(initialData.formState.usi?.usiExemptionLetter || ""));
      formData.append("transcript", JSON.stringify(initialData.formState.schoolingQualifications?.transcripts || []));
      formData.append("creditEvidence", JSON.stringify(initialData.formState.rplCredit?.creditEvidence || []));
      response = await axios.post(
        `${functionsURL}/api/file/contact`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }
    return response.data;
  } catch (error) {
    return error;
  }
};

/**
 * Get all users from Axcelerate
 * Fetches contact data from the Axcelerate API report
 */
export const getAllUsers = async () => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not signed in");

    const token = await user.getIdToken(); 

    const response = await axios.post(
      `${functionsURL}/api/axcelerate/contacts`,
      {
        reportID: "94328",
        displayLength: 1000,
        offsetRows: 0
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      data: response.data.DATA || []
    };
  } catch (error) {
    console.error("Error fetching Axcelerate users:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch users",
      data: []
    };
  }
};
